<template>
    <section>
        <b-row class="grid-header" v-if="!hideAction">
            <b-col cols="12">
            <div class="pull-right mb-1">
                <b-button
                v-if="checkClaim(CAN_EDIT_REQUIREMENTS)"
                size="sm"
                variant="primary"
                :disabled="checkedRowItemIds.length == 0"
                @click="onAddToSources()"
                class="mr-1">
                Post to Source
                </b-button>
                <b-button size="sm" variant="primary"
                :disabled="checkedRowItemIds.length == 0"
                @click="onRelease()">
                    Release
                </b-button>
            </div>
            </b-col>
        </b-row>
        <grid-component
            isResizable
            :gridId="inventoryAllocatedGridId"
            :itemData="itemData"
            :navigationField="'partNumber'"
            :dynamicValToLink="'-split-'"
            :onDynamicNav="showDetail"
            :fields="fields"
            @checkedItem="checkedRowItemIds=$event"
        />

        <b-modal id="split-details-modal-allocated" size="lg" ref="split-details-modal-allocated" hide-footer>
            <template slot="modal-header">
                <h5 class="modal-title">
                    {{ 'Inventory Split Details for Part ' + inventoryOnSplit.partNumber }}
                    <i v-show="isLoadingSplit" class="fa fa-spinner fa-pulse fa-fw"></i>
                </h5>
            </template>
            <inventory-split-component />
        </b-modal>
    </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import GridComponent from '@/shared/components/GridComponent';
import fields from './fields';
import InventorySplitComponent from '@/shared/components/InventorySplits';
import { GRID_ID } from '@/shared/constants';

export default {
    components: {
        GridComponent,
        InventorySplitComponent
    },
    props: {
        reqLineId: {
            type: [Number, String],
            default: 0
        },
        salesOrderLineId: {
            type: [Number, String],
            default: 0
        },
        inventoryId: {
            type: [Number, String],
            default: 0
        },
        hideAction: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            fields,
            checkedRowItemIds: [],
            inventoryAllocatedGridId: GRID_ID.INVENTORY_SALES_ORDERS_ALLOCATED_GRID,
            inventoryOnSplit: {},
            isLoadingSplit: false,
        }
    },
    computed: {
        ...mapGetters('inventory', ['allocationsList']),
        itemData() {
            return this.allocationsList;
        },
        allocationsSelected() {
            return this.allocationsList.filter(allocated => this.checkedRowItemIds.includes(allocated.id));
        }
    },
    methods: {
        ...mapActions('inventory', ['getAllocationsBySalesOrderLineId','getAllocationsByInventoryId', 'releaseAllocated', 'getInventorySplits']),
        ...mapActions('salesOrderLineSources', ['addSources']),
        // ...mapMutations('inventory', ['setInventorySplitList']),
        ...mapMutations('inventory', {inventorySetItem: 'setItem'}),
        async getData() {
            if(this.salesOrderLineId){
                await this.getAllocationsBySalesOrderLineId(this.salesOrderLineId);
            }else if(this.inventoryId){
                await this.getAllocationsByInventoryId(this.inventoryId);
            }
        },
        async onRelease() {
            await this.releaseAllocated({
                salesOrderLineId: this.salesOrderLineId,
                allocations: this.allocationsSelected
            });
            this.$snotify.success('Successfully Released Selected Inventories');
            this.$emit('refreshAvailableParts');
        },
        async showDetail(row) {
          try {
            this.isLoadingSplit = true;
            // this.setInventorySplitList([]);
            this.inventorySetItem({ resource:'inventorySplitList', payload: [] });
            this.inventoryOnSplit = row;
            this.$bvModal.show('split-details-modal-allocated');
            await this.getInventorySplits(row.inventoryId);
            this.isLoadingSplit = false;
          }catch (e) {
            this.isLoadingSplit = false;
          }
        },
        async onAddToSources() {
            let obj = this.allocationsSelected.map(allocations => {
                return {
                    id: 0,
                    salesOrderLineId: this.salesOrderLineId,
                    inventoryId: allocations.inventoryId,
                    quantity: allocations.onHand || 0,
                    partId: allocations.partId,
                    cost: allocations.cost || 0,
                    active: allocations.active,
                };
            });

            this.$snotify.info('Posting Inventory to Source', 'Sources');
            await this.addSources(obj).then(() => {
                this.checkedRowItemIdsArr = [];
                this.$snotify.success('Posted Inventory to Source', 'Sources');
            });
        },
    },
    watch: {
        salesOrderLineId() { this.getData(); },
        inventoryId() { this.getData(); }
    },
    mounted() {
        if (this.salesOrderLineId || this.inventoryId) { this.getData(); }
    }
}
</script>

<style>

</style>